import React from "react";
import { useLanguage } from "../../Context/LanguageContext";
import "../Projects/ProjectCard.css";

function ProjectCard({ project }) {
  const { language } = useLanguage();

  return (
    <div className="project-card">
      <div className="project-img">
        <img src={project.img} alt="" />
      </div>
      <div
        className={
          language === "arabic" ? "project-info arabic" : "project-info"
        }
      >
        <h3>{project.title}</h3>
        <p>{project.date}</p>
        <p>{project.side}</p>
        <p>{project.status}</p>
        <p>{project.personal}</p>
        <p>{project.description}</p>

        <div
          className={
            project.title === "Personal website" ||
            project.title === "موقع الويب الشخصي"
              ? "hidden"
              : "project-links"
          }
        >
          <a
            className="project-link"
            target="_blank"
            href={project.code}
            rel="noopener noreferrer"
          >
            {language === "arabic" ? " كود المشروع " : "Project code"}
          </a>
          {!project.live ? (
            ""
          ) : (
            <a
              className="project-link"
              target="_blank"
              href={project.live}
              rel="noopener noreferrer"
            >
              {language === "arabic" ? " عرض المشروع " : "Live website"}
            </a>
          )}
        </div>
      </div>
    </div>
  );
}

export default ProjectCard;
